<div class="flex wrapper column">
  <div class="content flex">
    <div class="data">
      <p class="title font-H4">{{ "Providers.Drivers.FirstName" | translate }}</p>
      <p class="value font-H3">{{ data.firstName || '_____' }}</p>
    </div>

    <div class="data">
      <p class="title font-H4">{{ "Providers.Drivers.LastName" | translate }}</p>
      <p class="value font-H3">{{ data.lastName || '_____' }}</p>
    </div>

    <div class="data">
      <p class="title font-H4">{{ "Providers.Drivers.IqamaExpireDate" | translate }}</p>
      <p class="value font-H3">{{ (data.iqamaExpiryDate | date : 'dd MMMM YYYY') || '_____'}}</p>
    </div>

    <div class="data">
      <p class="title font-H4">{{ "Providers.Drivers.LicenseExpiryDate" | translate }}</p>
      <p class="value font-H3">{{ (data.licenseExpiryDate | date : 'dd MMMM YYYY') || '_____'}}</p>
    </div>

    <div class="data">
      <p class="title font-H4">{{ "Providers.Drivers.LicenseType" | translate }}</p>
      <p class="value font-H3">{{ ('Enum.LicenseType.' + data.licenseType | translate) || '_____' }}</p>
    </div>

    <div class="data">
      <p class="title font-H4">{{ "Providers.Drivers.Nationality" | translate }}</p>
      <p class="value font-H3">{{ data.nationality ? ('Enum.Nationality.' + data.nationality | translate) : '_____' }}</p>
    </div>

    <div class="data">
      <p class="title font-H4">{{ "Providers.Drivers.SponsorName" | translate }}</p>
      <p class="value font-H3">{{ data.owner || '_____' }}</p>
    </div>

    <div class="data">
      <p class="title font-H4">{{ "Providers.Drivers.IssueNumber" | translate }}</p>
      <p class="value font-H3">{{ data.issueNumber || '_____' }}</p>
    </div>
  </div>

  <div class="my-5">
    <mat-divider class="pos-static"></mat-divider>
  </div>

  <div class="flex actions">
    <button mat-raised-button class="btn-secondary btn" (click)="confirmed.emit(false)">{{ "Buttons.Cancel" | translate }}</button>
    <button mat-raised-button class="btn-primary btn" (click)="confirmed.emit(true)">{{ "Buttons.Confirm" | translate }}</button>
  </div>
</div>
